import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { debounceTime } from 'rxjs/operators';
import { StepThreeSliderComponent } from './step-three-slider/step-three-slider.component';
import { ThreeDService } from 'src/app/services/three-d.service';
import { ProductClassificationService } from 'src/app/services/product-classification.service';
import { ProductClass } from 'src/app/enums/productClass.enum';

@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss'],
})
export class StepThreeComponent implements OnInit {
  length: number;
  width: number;
  height: number;
  widthPro: boolean = false;
  lengthPro: boolean = false;
  heightPro: boolean = false;

  @ViewChild('lengthSlider', { static: true }) lengthSlider: StepThreeSliderComponent;
  @ViewChild('widthSlider', { static: true }) widthSlider: StepThreeSliderComponent;
  @ViewChild('heightSlider', { static: true }) heightSlider: StepThreeSliderComponent;

  constructor(
    private configurationService: ConfigurationService,
    private threeDService: ThreeDService,
    private productClassificationService: ProductClassificationService
  ) {}

  ngOnInit() {
    this.threeDService.setZoom(5);
    this.threeDService.resetDefaultCamera(true);
    this.configurationService.furthestStepVisited = 3;

    this.length = this.configurationService.length;
    this.width = this.configurationService.width;
    this.height = this.configurationService.height;
    this.checkCellSize();
    this.checkCellHeight(this.configurationService.height);

    this.lengthSlider.valueChange.pipe(debounceTime(500)).subscribe(length => this.updateLength(length));
    this.widthSlider.valueChange.pipe(debounceTime(500)).subscribe(width => this.updateWidth(width));

    this.heightSlider.valueChange.pipe(debounceTime(500)).subscribe(height => this.updateHeight(height));
  }

  updateLength(length: number) {
    this.configurationService.length = length;
    this.checkCellSize();
  }
  updateWidth(width: number) {
    this.configurationService.width = width;
    this.checkCellSize();
  }
  updateHeight(height: number) {
    this.configurationService.height = height;
    this.checkCellHeight(height);
  }

  checkCellHeight(height: number) {
    if (!this.productClassificationService.IsStandardCellHeight(height)) {
      this.configurationService.productClass = ProductClass.PRO;
      this.heightPro = true;
    } else {
      this.configurationService.productClass = ProductClass.STANDARD;
      this.heightPro = false;
    }
  }

  checkCellSize() {
    this.widthPro = !this.productClassificationService.isStandardCellSideMin(this.configurationService.width);
    this.lengthPro = !this.productClassificationService.isStandardCellSideMin(this.configurationService.length);
    if (!this.productClassificationService.IsStandardCellSize(this.configurationService.width, this.configurationService.length)) {
      const wProMax = !this.productClassificationService.isStandardCellSideMax(this.configurationService.width);
      const lProMax = !this.productClassificationService.isStandardCellSideMax(this.configurationService.length);
      if (!this.widthPro && !this.lengthPro && wProMax) {
        this.widthPro = true;
        this.lengthPro = lProMax;
      } else if (!this.widthPro && !this.lengthPro && lProMax) {
        this.lengthPro = true;
        this.widthPro = wProMax;
      }
    }
    this.configurationService.productClass = this.widthPro || this.lengthPro ? ProductClass.PRO : ProductClass.STANDARD;
  }

  get maxWidth(): number {
    if (this.configurationService.length > 3900) {
      return 3900;
    }
    return 12000;
  }

  get maxLength(): number {
    if (this.configurationService.width > 3900) {
      return 3900;
    }
    return 12000;
  }
}
